import { useEffect } from 'react';

// New UI only (docs/ui_redesign/18-ux-review.md, R8): a grid wider than its space says so. The grid root gets
// data-apw2-more-left / data-apw2-more-right while columns are hidden on that side, and redesign.css draws a fade (or a
// shadow on the pinned column) there. Scroll events don't bubble, so one capturing listener on the document hears
// every grid.
const SCROLLER = '.MuiDataGrid-virtualScroller';

export function cueFor(scroller) {
	const max = scroller.scrollWidth - scroller.clientWidth;
	return { left: max > 1 && scroller.scrollLeft > 1, right: max > 1 && max - scroller.scrollLeft > 1 };
}

function mark(scroller) {
	const grid = scroller.closest('.MuiDataGrid-root');
	if (!grid) return;
	const { left, right } = cueFor(scroller);
	const set = (name, on) => { if (on && !grid.hasAttribute(name)) grid.setAttribute(name, ''); else if (!on && grid.hasAttribute(name)) grid.removeAttribute(name); };
	set('data-apw2-more-left', left);
	set('data-apw2-more-right', right);
}

export default function ScrollCue() {
	useEffect(() => {
		let frame = 0;
		const all = () => { frame = 0; document.querySelectorAll(SCROLLER).forEach(mark); };
		const later = () => { if (!frame) frame = requestAnimationFrame(all); };
		const onScroll = e => { if (e.target && e.target.matches && e.target.matches(SCROLLER)) mark(e.target); };
		document.addEventListener('scroll', onScroll, true);
		window.addEventListener('resize', later);
		const observer = new MutationObserver(later);
		observer.observe(document.body, { childList: true, subtree: true });
		all();
		return () => { document.removeEventListener('scroll', onScroll, true); window.removeEventListener('resize', later); observer.disconnect(); if (frame) cancelAnimationFrame(frame); };
	}, []);
	return null;
}
